/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaricoOraDTO
 */
export interface CaricoOraDTO {
    /**
     * 
     * @type {number}
     * @memberof CaricoOraDTO
     */
    rosticceria?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CaricoOraDTO
     */
    medi?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CaricoOraDTO
     */
    pesanti?: number | null;
}

/**
 * Check if a given object implements the CaricoOraDTO interface.
 */
export function instanceOfCaricoOraDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CaricoOraDTOFromJSON(json: any): CaricoOraDTO {
    return CaricoOraDTOFromJSONTyped(json, false);
}

export function CaricoOraDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaricoOraDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rosticceria': !exists(json, 'rosticceria') ? undefined : json['rosticceria'],
        'medi': !exists(json, 'medi') ? undefined : json['medi'],
        'pesanti': !exists(json, 'pesanti') ? undefined : json['pesanti'],
    };
}

export function CaricoOraDTOToJSON(value?: CaricoOraDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rosticceria': value.rosticceria,
        'medi': value.medi,
        'pesanti': value.pesanti,
    };
}

